<div class="container content-cart bg-white">
  <form [formGroup]="checkoutform" style="margin-bottom: -20px;">
    <div class="row background-grey shadow-sm">
      <div class="col d-flex justify-content-between align-items-center">
        <div class="float-left" (click)="onBackClick()">
          <i class="far icon-back-inline p-4"></i>
        </div>
        <div class="font-weight-bold font-size-16 text-center">
          <label class="text-truncate font-weight-bold mt-2 h6">
            <span *ngIf="userInfo.userPkid > 0">
              {{userInfo.firstName}}
            </span>
            <span *ngIf="!userInfo.userPkid">Your</span>
            Checkout
          </label>
        </div>
        <div class="float-right" (click)="overlayOpen()">
          <i class="far icon-help-inline p-4"></i>
        </div>
      </div>
    </div>

    <div class="row mt-3 form-group">
      <div class="col text-center" *ngIf="userSelectedStore">
        <label
          class="card-title text-blue h5 font-weight-bold m-0 mb-0 text-capitalize text-break">{{userSelectedStore.serviceCompanyName}}</label>
        <div class="text-capitalize">
          <i class="text-danger fas fa-map-marker-alt mr-1"></i>
          <small class="text-break">{{userSelectedStore.serviceLocationName}}</small>
        </div>

      </div>
    </div>

    <div class="row mx-2">
      <div class="col-12 text-center" style="background-color: #0b2b3d !important;border-radius: 10px;">
        <div style="color: white !important;" class="p-1">
          <!-- <i class="fas font-size-14 fa-motorcycle pr-1"></i> -->
          <span *ngIf="serviceType === 'DELIVERY'">Delivery</span>
          <span *ngIf="serviceType === 'DINE_IN' && !IsLocationQRCode">DineIn</span>
          <span *ngIf="serviceType === 'COLLECTION'">Pickup</span>
          &nbsp;
          <label class="card-title m-0 mb-0 text-capitalize text-break">
            {{orderDatetime}}
          </label>
        </div>
      </div>

    </div>

    <div class="row mx-2 mt-2">
      <div class="col-12 p-0">

        <div class="card border-0 shadow-sm rounded amount-to-pay-card my-2">
          <div class="card-body d-flex justify-content-between align-items-center px-3 py-3">
            <div class="d-flex flex-column">
              <span class="font-weight-bold h6 mb-1" *ngIf="!isRedeem">{{'COMMON.AMOUNT_TO_PAY' |
                translate }}</span>
              <span class="font-weight-bold-500 text-muted small mb-0">{{'CHECKOUT_PAGE.PAY_AND_COMPLETE' | translate
                }}</span>
            </div>
            <div class="text-right text-nowrap" *ngIf="userSelectedStore">
              <small class="fa-xs-small-70 text-secondary font-weight-bold"
                *ngIf="settings && settings.company_currency_position === 'BACK'">
                {{settings.company_currency}}
              </small>
              <span class="text-blue font-weight-bold amount-value">{{(balanceToPay).toFixed(2)}}</span>
              <small class="fa-xs-small-70 text-secondary font-weight-bold"
                *ngIf="settings && settings.company_currency_position === 'FRONT'">
                {{settings.company_currency}}
              </small>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- <div class="row form-group" *ngIf="!usertoken">
      <div class="col text-right my-3 mx-0">
        <span (click)="onSignInClick()" class="badge rounded-pill bg-dark text-white p-2 mr-5 cursor font-size-11">
          <span *ngIf="!qrCodeScanned" style="color: #fffb04 !important;">Proceed</span>
        </span>
      </div>
    </div> -->
  </form>

  <!-- payments -->
  <div class="bg-white mb-5">

    <div class="row no-gutters form-group pb-1" *ngIf="alerts.length > 0">
      <div class="col">
        <div *ngFor="let alert of alerts">
          <alert [type]="alert.type" [isOpen]="alert.isOpen" [dismissOnTimeout]="alert.timeout"
            (onClosed)="onClosed(alert)">{{ alert.msg }}</alert>
        </div>
      </div>
    </div>



    <!-- Loyalty Balance -->
    <div class="row mx-1" style="margin-bottom: -18px;" *ngIf="userInfo.points > 0">
      <div class="col">
        <div class="row mt-2">
          <div class="col font-weight-bold-500">
            <div class="d-flex align-items-center">
              <i class="fa fa-info-circle mr-2 text-danger" style="font-size: 1.1rem;"></i>
              <span class="h6 mb-0 text-blue">Loyalty Balance</span>
            </div>
          </div>


          <div class="col text-right h5 text-blue">
            <span class="font-weight-bold">
              <span class="font-weight-bold" *ngIf="userSelectedStore">
                <small class="fa-xs-small-70" *ngIf="settings && settings.company_currency_position === 'BACK'">
                  {{settings.company_currency}}
                </small>
                {{(totalLoyaltyAmount -loyaltyAmount)?.toFixed(2)}}
                <small class="fa-xs-small-70" *ngIf="settings && settings.company_currency_position === 'FRONT'">
                  {{settings.company_currency}}
                </small>
              </span>
              / <span style="font-size: 15px;">{{totalLoyaltyPoints - remainingPoints}} pts</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- Loyalty Balance -->
    <div class="row cursor" *ngIf="userInfo.points > 0 && showonlinePayments">
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="row m-2 p-2 rounded background-grey">
              <div class="col">
                <div class="row">
                  <div class="col">

                    <div class="d-flex justify-content-between align-items-center">
                      <!-- Left: Icon + Text -->
                      <div class="d-flex align-items-center flex-grow-1">
                        <div class="icon-container d-flex">
                          <i class="icon-loyalty p-4"></i>
                        </div>
                        <label class="cursor text-dark mb-0 ml-2">
                          <span class="h6 font-weight-bold-500 mb-0">
                            Redeem Loyalty
                          </span>
                        </label>
                      </div>

                      <!-- Right: Input -->
                      <div class="d-flex justify-content-end">
                        <input [(ngModel)]="loyaltyAmount" (change)="onPointsChanged()" [min]="0"
                          (input)="onInputLimit($event)" [max]="allowedPointsToUse"
                          (keydown)="preventNegativeInput($event)" type="number" class="form-control" style="width: 75px;
                height: 46px;
                padding: 0 5px;
                font-size: 18px;
                font-weight: bold;
                text-align: right;
                margin-right: -15px;" />
                      </div>
                    </div>

                  </div>


                </div>

              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="row cursor" *ngIf="false">
      <div class="col">
        <div class="row">
          <div class="col">
            <div class="row m-2 p-2 rounded background-grey">
              <div class="col">
                <div class="row">
                  <div class="col">

                    <div class="d-flex justify-content-between align-items-center">
                      <!-- Left: Icon + Text -->
                      <div class="d-flex align-items-center flex-grow-1">
                        <div class="icon-container d-flex">
                          <i class="icon-loyalty p-4"></i>
                        </div>
                        <label class="cursor text-dark mb-0 ml-2">
                          <span class="h6 font-weight-bold-500 mb-0">
                            Use your balance at counter
                          </span>
                        </label>
                      </div>


                    </div>

                  </div>


                </div>

              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row mx-1" *ngIf="loyaltyAmount > 0">
      <div class="col">
        <div class="row mt-2">
          <div class="col-8 font-weight-bold-500">
            <label class="h6">
              Select Payments for balance:
            </label>
          </div>
          <div class="col-4 text-right h5">
            <span class="font-weight-bold" *ngIf="userSelectedStore">
              <small class="fa-xs-small-70" *ngIf="settings && settings.company_currency_position === 'BACK'">
                {{settings.company_currency}}
              </small>
              {{getAmountToPay}}
              <small class="fa-xs-small-70" *ngIf="settings && settings.company_currency_position === 'FRONT'">
                {{settings.company_currency}}
              </small>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row cursor " *ngFor="let ptype of paymentTypes;let i=index;">
      <div class="col">
        <div class="row" (click)="onPaymentExpand(ptype,i,ptype.collapsed)" [attr.aria-expanded]="ptype.collapsed"
          aria-controls="ptype.type">
          <div class="col">
            <div class="row m-2 p-2 rounded" [ngClass]="ptype.selected ? 'payment-selected-bg' : 'background-grey'">
              <div class="col">
                <div class="row">
                  <div class="col" *ngIf="ptype.type === 'loyalty'">

                    <div class="d-flex justify-content-between align-items-center">
                      <div class="icon-container d-flex">
                        <i class="far icon-loyalty p-4"></i>
                      </div>
                      <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                        [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                        <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                      </label>
                    </div>
                  </div>


                  <div class="col" *ngIf="ptype.type === 'fpx'">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="icon-container d-flex">
                        <i class="far icon-fpx-inline p-4"></i>
                      </div>
                      <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                        [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                        <span class="h6 mt-2 font-weight-bold-500 mt-1">Online Banking</span>
                      </label>
                    </div>
                  </div>
                  <div class="col" *ngIf="ptype.type === 'ewallets'">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="icon-container d-flex">
                        <i class="far icon-touchandgo-inline p-4"></i>
                        <i class="far icon-grabpay-inline p-4"></i>
                        <i class="far icon-alipay-inline p-4"></i>
                        <i class="far icon-boost-inline p-4"></i>
                      </div>
                      <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                        [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                        <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                        <span>{{ptype?.description}}</span>
                      </label>
                    </div>
                  </div>

                  <div class="col" *ngIf="ptype.type === 'card'">

                    <div class="d-flex justify-content-between align-items-center">
                      <div class="icon-container d-flex">
                        <i class="far icon-card-visa-inline p-4"></i>
                        <i class="far icon-card-master-inline p-4"></i>
                      </div>
                      <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                        [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                        <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                      </label>
                    </div>

                  </div>
                  <div class="col" *ngIf="ptype.type === 'DuitNow'">

                    <div class="d-flex justify-content-between align-items-center">
                      <div class="icon-container d-flex">
                        <i class="far icon-duitnow-inline p-4"></i>
                      </div>
                      <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                        [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                        <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col" *ngIf="ptype.type === 'payatcounter'">

                    <div class="d-flex justify-content-between align-items-center">
                      <div class="icon-container d-flex">
                        <i class="far icon-counterpay-inline p-4"></i>
                      </div>
                      <label for="{{ptype.name}}" class="cursor mt-2 p-2"
                        [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                        <span class="h6 mt-2 font-weight-bold-500 mt-1">{{ptype.name}}</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-1">
                    <label *ngIf="ptype.showicon" class="m-0 float-right p-2 pt-08 pr-2 cursor"
                      [ngClass]="ptype.selected ? 'payment-text-primary' : 'text-dark'">
                      <i class="fas fa-chevron-down float-right" *ngIf="ptype.collapsed"></i>
                      <i class="fas fa-chevron-up float-right" *ngIf="!ptype.collapsed"></i>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <span *ngIf="ptype.option_selected"
                      [ngClass]="ptype.option_selected ? 'payment-text-primary' : 'text-dark'">
                      <span *ngIf="ptype.type !== 'payatcounter'">{{ptype.selected}} Selected</span>
                      <span *ngIf="ptype.type === 'payatcounter'">
                        <span *ngIf="!chargetoRoom">{{ptype.selected}} Selected</span>
                        <span *ngIf="chargetoRoom">Charge to my room Selected</span>
                      </span>
                    </span>
                  </div>
                </div>
                <!-- <div class="row">
                    <div class="col">
                      <small *ngIf="ptype.type === 'fpx' && !ptype.option_selected">Select one from the list of 25 banks</small>
                      <small *ngIf="ptype.type === 'ewallets' && !ptype.option_selected">Select one from the list of 13 ewallets</small>
                    </div>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
        <div id="{{ptype.type}}" [collapse]="ptype.collapsed" [isAnimated]="true" class="container">
          <div *ngIf="environment === 'Production'">
            <div class="row align-items-center payment-option-row" [class.is-selected]="option.selected"
              *ngFor="let option of ptype.production_list;let j=index;">
              <div class="col-1 cursor">
                <div class="round">
                  <input [checked]="option.selected" name="{{option.value}}" type="checkbox" id="{{option.value}}{{j}}"
                    (change)="onPaymentTypeSelect($event, ptype, option, i, j)" />
                  <label class="cursor" for="{{option.value}}{{j}}"></label>
                </div>
              </div>
              <div class="col">
                <label for="{{option.value}}{{j}}" class="pl-2 text-dark cursor option-text">
                  {{option.text}}
                </label>
                <span class="pl-2 text-primary fa-xs-small-70 description"
                  [innerHTML]="option.description ? option.description : ''"></span>
                <span class="text-primary fa-xs-small-70 description text-center"
                  [innerHTML]="option.subDescription ? option.subDescription : ''"></span>
              </div>
            </div>
          </div>
          <div *ngIf="environment === 'Testing' || environment === 'Development' || environment === 'Staging'">
            <div class="row align-items-center payment-option-row" [class.is-selected]="option.selected"
              *ngFor="let option of ptype.staging_list; let j = index;">

              <div class="col-1 cursor">
                <div class="round">
                  <input [checked]="option.selected" name="{{option.value}}" type="checkbox" id="{{option.value}}{{j}}"
                    (change)="onPaymentTypeSelect($event, ptype, option, i, j)" />
                  <label class="cursor" for="{{option.value}}{{j}}"></label>
                </div>
              </div>
              <div class="col">
                <label for="{{option.value}}{{j}}" class="pl-2 text-dark cursor option-text">
                  {{option.text}}
                </label>
                <span class="pl-2 text-primary fa-xs-small-70 description"
                  [innerHTML]="option.description ? option.description : ''"></span>
                <span class="text-primary fa-xs-small-70 description text-center"
                  [innerHTML]="option.subDescription ? option.subDescription : ''"></span>
              </div>

            </div>



          </div>

        </div>
      </div>
    </div>





    <div *ngIf="displayPaymentSpecific && showonlinePayments && paymentGateway === 'GHL'">
      <div class="row border rounded cursor mx-1 my-2">
        <div class="col-1 mt-4 cursor">
          <div class="round">
            <input [checked]="cardselected" name="payment" type="checkbox" id="card"
              (change)="GHLPaymentSelect($event,'CARD')" />
            <label class="cursor" for="card"></label>
          </div>
        </div>
        <div class="col-6 mt-4">
          <label for="card">
            <span class="font-weight-bold-500">
              Credit/Debit Card
            </span>
          </label>
        </div>
        <div class="col-1"></div>
        <div class="col my-2 text-right">
          <div class="row no-gutters">
            <div class="col border rounded mr-1">
              <i class="far icon-card-visa-inline"></i>
            </div>
            <div class="col border rounded">
              <i class="far icon-card-master-inline"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row border rounded cursor mx-1 my-2">
        <div class="col-1 mt-4 cursor mb-1">
          <div class="round">
            <input [checked]="showfpxlist" name="payment" type="checkbox" id="payment"
              (change)="GHLPaymentSelect($event,'FPX')" />
            <label class="cursor" for="payment"></label>
          </div>
        </div>
        <div class="col mt-4 mb-1">
          <label for="payment">
            <span class="font-weight-bold-500">
              FPX
            </span>
          </label>
        </div>
      </div>

      <div class="row px-1 my-2" *ngIf="showfpxlist">
        <div class="col"
          *ngIf="environment === 'Testing' || environment === 'Development' || environment === 'Staging'">
          <ng-select [items]="fpxStagingList" bindLabel="text" [clearable]="false" bindValue="value"
            appearance="outline" placeholder="Online Payment" [searchable]="true" class="" type="Hour"
            (change)="onFpxChange($event)" [(ngModel)]="selectedFPX">
          </ng-select>
        </div>
        <div class="col" *ngIf="environment === 'Production'">
          <ng-select [items]="fpxProductionList" bindLabel="text" [clearable]="false" bindValue="value"
            appearance="outline" placeholder="Select Payment" [searchable]="true" class="" type="Hour"
            (change)="onFpxChange($event)" [(ngModel)]="selectedFPX">
          </ng-select>
        </div>
      </div>

      <div class="row border rounded cursor mx-1 my-2">
        <div class="col-1 mt-4 cursor">
          <div class="round">
            <input [checked]="showwalletlist" name="payment" type="checkbox" id="paymentwallet"
              (change)="GHLPaymentSelect($event,'EWALLETS')" />
            <label class="cursor" for="paymentwallet"></label>
          </div>
        </div>
        <div class="col mt-4">
          <label for="paymentwallet">
            <span class="font-weight-bold-500">
              e-Wallets
            </span>
          </label>
        </div>
        <div class="col-1"></div>
        <div class="col mt-1 my-2 text-right">
          <div class="row no-gutters">
            <div class="col border rounded mr-1">
              <i class="far icon-touchandgo-inline"></i>
            </div>
            <div class="col border rounded">
              <i class="far icon-grabpay-inline"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row px-1 my-2" *ngIf="showwalletlist">
        <div class="col">
          <ng-select [items]="eWalletList" bindLabel="text" [clearable]="false" bindValue="value" appearance="outline"
            placeholder="Select eWallet" [searchable]="true" class="" type="Hour" (change)="onWalletChange($event)"
            [(ngModel)]="selectedWallet">
          </ng-select>
        </div>
      </div>


    </div>


    <div class="footer-cart bg-white pb-2">
      <div class="container pl-0 pr-0">
        <div class="row text-center" *ngIf="paymentErrorMsg">
          <div class="col">
            <span class="text-danger">{{paymentErrorMsg}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button type="button" (click)="onPaynowClick()" [attr.disabled]="paynowclickeddisable ? 'disabled' : null"
              class="btn btn-block box-shadow-none p-2 pay-now-btn">
              <div class="font-weight-bold d-flex align-items-center justify-content-center" style="font-size: larger;">
                <i class="fas fa-lock mr-2"></i>
                <span>{{ payatcountenabled ? 'Press ok & Proceed to Counter' : 'Pay Now' }}</span>
              </div>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center pt-2">
            <span class="payment-secure-note">
              <i class="fas fa-shield-alt mr-1"></i> Your payment is secure and encrypted
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>
  <br />
  <br />
  <br />
  <br />
</div>


<ng-template #signup>
  <div class="modal-header text-center" style="background-color: #264061;">
    <h3 class="modal-title w-100 font-weight-bold"
      style="color: #bfd06a;font-family: Brush-Script-Std-Medium !important;">Sign Up & Enjoy</h3>
  </div>
  <div class="modal-body" style="background-color: #fafafa !important;" [formGroup]="signupform">
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Cash Backs</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Discounts</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Referral Discounts</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <label class="font-weight-bold-500 mb-0 h4" style="color: #2f4d74 !important;">Other special offers</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <ngx-intl-tel-input class="" [cssClass]="'form-control'" [preferredCountries]="preferredCountries" #mobile
          [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
          [selectedCountryISO]="selectedCountryISO" [maxLength]="15" formControlName="mobile"
          [ngClass]="{'has-error': ((signupform.get('mobile').touched || signupform.get('mobile').dirty) &&  signupform.get('mobile').errors)}"
          [phoneValidation]="true" [separateDialCode]="separateDialCode" name="mobile" id="signupmobile">
        </ngx-intl-tel-input>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button style="background-color: #1f487c !important;" (click)="onSignUpNowClick()"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none rounded btn-block" type="button">
          SIGN UP
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <small>Used in accordance with our <span class="text-primary cursor" (click)="onClickPrivacy()"><u>Privacy
              Policy</u></span></small>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #paymentfailure>
  <!-- <div class="modal-header">
    <span class="font-weight-bold">Payment Failed</span>
    <i class="fas fa-times fa-lg cursor close" (click)="onCloseClick()"></i>
  </div>
  <div class="modal-body rounded">
    <div class="row border-bottom">
      <div class="col text-center">
        We could not process your payment due to {{paymentError}}.<br>
        Your order details have been saved in your cart.
      </div>
    </div>
  </div> -->


  <div class="modal-body inquiry-styles">

    <div class="row">
      <div class="col text-center">

      </div>
      <div class="col-1">
        <i *ngIf="!isLoading" class="fas fa-times fa-lg cursor close" (click)="onCloseClick()"></i>
      </div>
    </div>
    <div *ngIf="isLoading" class="d-flex justify-content-center mb-2">
      <div class="spinner-border text-blue" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div *ngIf="isLoading " class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>We are in process of getting response from the bank</p>
        <p>Please hold...</p>
      </div>
    </div>
    <div *ngIf="!isLoading && paymentDone" class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>We have got the response your payment is successful</p>
      </div>
    </div>

    <div *ngIf="!isLoading && !paymentDone" class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>We have got the response: {{paymentResponse}}</p>

      </div>
    </div>

  </div>
</ng-template>

<ng-template #qrPayment>

  <div class="modal-body inquiry-styles">

    <!-- <div class="row">
      <div class="col text-center">

      </div>
      <div class="col-1">
        <i class="fas fa-times fa-lg cursor close" (click)="showConfirmCloseQrPayment()"></i>
      </div>
    </div> -->
    <ng-container *ngIf="qrImageSrc">
      <div class="d-flex justify-content-center align-items-center">
        <div class="text-center text-danger font-weight-bold">
          <h5>Countdown: {{ displayTime }}</h5>
        </div>
      </div>


      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <img [src]="qrImageSrc" alt="QR Code" style="width: 180px; height: auto;" />

        </div>
      </div>

      <div *ngIf="displayTime === '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <span>{{bankResult}}</span>
          <p>{{inquiryMessage}}</p>

        </div>
      </div>

      <div *ngIf="displayTime === '00:00'" class="d-flex flex-column justify-content-center align-items-center"
        style="gap: 10px;">

        <button class="btn btn-primary w-100" style="max-width: 300px;background-color: #0988b5; border-radius:10px"
          (click)="closeQrPayment()">
          Try again or Select another payment method
        </button>

        <button class="btn w-100" style="max-width: 200px;
    border-radius: 34px;
    background-color: #b2afaf;
    color: black;" (click)="closeQrPayment()">
          Cancel
        </button>

      </div>




      <div *ngIf="displayTime !== '00:00'" class="d-flex flex-column justify-content-center align-items-center">
        <span>For quick result please follow step</span>
        <span>a) Screenshot the QR and save to your photos</span>
        <span>b) Open Bank app, scan, select <b>scan from gallery</b></span>
      </div>


      <div *ngIf="displayTime !== '00:00'" class="d-flex justify-content-center mb-2">
        <div class="spinner-border text-blue" role="status">
          <span class="visually-hidden"></span>
        </div>
      </div>
      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <p [ngClass]="inquiryCount === 0 ? 'text-primary' : 'text-warning'">
            {{inquiryMessage}}
          </p>
        </div>
      </div>

      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">
          <p style="color: red;">
            DO NOT CLOSE THIS PAGE ONCE FINISHED MAKING PAYMENT,
            OPEN THE PAGE AGAIN AND ACKNOWLEDGE ORDER TICKET
          </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!qrImageSrc">
      <div class="row">
        <div class="col text-center">

        </div>
        <div class="col-1">
          <i class="fas fa-times fa-lg cursor close" (click)="closeQrPayment()"></i>
        </div>
      </div>
      <div *ngIf="displayTime !== '00:00'" class="h6 d-flex justify-content-center align-items-center">
        <div class="text-center font-weight-bold">

          <span>Could not connect to DuitNow. Please try again later!</span>
        </div>
      </div>
    </ng-container>

    <div *ngIf="isManual" class="d-flex justify-content-center mb-2">
      <div class="spinner-border text-blue" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div *ngIf="isManual" class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p [ngClass]="inquiryCount === 0 ? 'text-primary' : 'text-warning'">
          {{inquiryMessage}}
        </p>
      </div>
    </div>


    <!-- <div *ngIf="displayTime === '00:00'" class="mt-3 d-flex flex-column justify-content-center align-items-center"
      style="gap: 10px;">

      <button class="btn btn-danger w-100" style="max-width: 300px;" (click)="manualInquiryQr()">Check status

      </button>

    </div> -->


  </div>
</ng-template>

<ng-template #cancelQrPayment>

  <div class="modal-body inquiry-styles">


    <div class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>Payment is still pending. Are you sure you want to cancel this transaction?</p>

      </div>
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <button class="btn btn-secondary mx-2" (click)="onPaymentCloseClick()">Yes</button>
      <button class="btn btn-primary mx-2" (click)="closeCancelQrPayment()">No</button>
    </div>




  </div>
</ng-template>

<div *ngIf="rhPaymentForm">
  <form method="post" [formGroup]="rhPaymentForm" target="_self">
    <input type="text" name="Revpay_Merchant_ID" formControlName="Revpay_Merchant_ID" hidden="">
    <input type="text" name="Payment_ID" formControlName="Payment_ID" hidden="">
    <input type="text" name="Bank_Code" formControlName="Bank_Code" hidden="">
    <input type="text" name="Reference_Number" formControlName="Reference_Number" hidden="">
    <input type="text" name="Amount" formControlName="Amount" hidden="">
    <input type="text" name="Currency" formControlName="Currency" hidden="">
    <input type="text" name="Transaction_Description" formControlName="Transaction_Description" hidden="">
    <input type="text" name="Customer_Name" formControlName="Customer_Name" hidden="">
    <input type="text" name="Customer_Email" formControlName="Customer_Email" hidden="">
    <input type="text" name="Customer_Contact" formControlName="Customer_Contact" hidden="">
    <input type="text" name="Customer_IP" formControlName="Customer_IP" hidden="">
    <input type="text" name="Key_Index" formControlName="Key_Index" hidden="">
    <input type="text" name="Return_URL" formControlName="Return_URL" hidden="">
    <input type="text" name="Backend_URL" formControlName="Backend_URL" hidden="">
    <input type="text" name="Signature" formControlName="Signature" hidden="">
    <input type="text" name="Promo_Code" formControlName="Promo_Code" hidden="">
    <input type="text" name="Customization" formControlName="Customization" hidden="">
  </form>
</div>

<ng-template #sessionEnded>


  <div class="modal-body inquiry-styles">


    <div class="h6 d-flex justify-content-center align-items-center">
      <div class="text-center font-weight-bold">
        <p>Your session ended. Please rescan the table QR to continue</p>

      </div>
    </div>

  </div>
</ng-template>

<app-loading-component></app-loading-component>

<ng-template #sessionExpired>
  <!-- <div class="modal-header text-center">    
    <i class="fas fa-times fa-lg cursor close" (click)="closePromo()"></i>
  </div> -->
  <div class="modal-body rounded">
    <div class="row form-group">
      <div class="col text-center">
        <label class="h3">Your session expired due to inactivity!!</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <button type="button" style="background-color:#151617 !important;"
          class="btn btn-block btn-sm btn-outline-secondary border-1 border-light-grey outline-0 box-shadow-none font-weight-bold font-size-11 pt-1 pb-1 bg-white"
          (click)="onSessionExpired()">
          <span style="color: #fffb04 !important;">OK</span>
        </button>
      </div>
    </div>

  </div>
</ng-template>


<div class="overlay" *ngIf="overlayDisplay">
  <app-ecom-contact-us (submitted)="contactUsEventEmitter($event)"></app-ecom-contact-us>
</div>


<ng-template #displayQROrderPhoneVerify>

  <div class="modal-body modal-styles" [formGroup]="userOTPForm">

    <div *ngIf="!register">

      <div *ngIf="isOtpVerified">
        <div class="row form-group">
          <div class="col text-center">
            <label class="text-dark h6 font-weight-bold-500">Order Payment</label>
          </div>
          <div class="col-1">
            <button type="button" style="margin-top: -10px !important;" class="close close-button text-dark"
              data-dismiss="modal" aria-label="Close" (click)="onCloseQROrderPhoneVerifyClick()">
              <span aria-hidden="true" style="font-size: 40px !important;">&times;</span>
            </button>
          </div>
        </div>
        <div class="row form-group">
          <div class="col text-center">
            <label class="font-weight-bold-500">Please set up password for easy ordering in future</label>
          </div>
        </div>

        <div class="row form-group">
          <div class="col">
            <button type="button" class="btn btn-outline-secondary btn-block bg-dark text-white"
              (click)="onSetupClick()" [disabled]="buttonClicked">Setup</button>
          </div>
        </div>

        <div class="row form-group">
          <div class="col">
            <button type="button" class="btn btn-outline-secondary btn-block bg-dark text-white"
              (click)="onSkipContinueClick()" [disabled]="buttonClicked">Skip and continue to payment</button>
          </div>
        </div>
      </div>

      <div *ngIf="!isOtpVerified">
        <div>
          <div class="row form-group">
            <div class="col text-center">
              <label class="h6 font-weight-bold-500" style="color: #9da6f8;">For Online payments we need to
                verify your phone
                number</label>
            </div>
            <div class="col-1">
              <button type="button" style="margin-top: -10px !important;" class="close close-button text-dark"
                data-dismiss="modal" aria-label="Close" (click)="onCloseQROrderPhoneVerifyClick()">
                <span aria-hidden="true" style="font-size: 40px !important;">&times;</span>
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col form-group">
              <label for="exampleInputEmail1" class="font-weight-bold-500 text-gray">Cell Phone</label>
              <ngx-intl-tel-input [cssClass]="'form-control form-control-lg border-0'"
                [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
                [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
                [phoneValidation]="true" [separateDialCode]="separateDialCode" name="mobile" formControlName="mobile"
                [ngClass]="{'has-error': ((userOTPForm.get('mobile').touched || userOTPForm.get('mobile').dirty) &&  userOTPForm.get('mobile').errors)}">
              </ngx-intl-tel-input>
            </div>
          </div>

          <div class="row form-group">
            <div class="col text-right">
              <button style="border-radius: 10px !important;" type="button"
                class="btn btn-sm btn-secondary font-weight-bold-500 box-shadow-none"
                (click)="onQROrderPhoneVerifyClick()" [disabled]="buttonClicked">
                Get OTP
              </button>
            </div>
          </div>

          <br />

          <div class="row form-group mx-2">
            <div class="col">
              <div>
                <div>
                  <label *ngIf="OTP_type === 'SCREEN_OTP'" class="text-gray font-weight-bold-500">Your OTP
                    is</label>
                  <label *ngIf="OTP_type !== 'SCREEN_OTP'"></label>
                </div>
                <label class="h5 blink" *ngIf="OTP_type === 'SCREEN_OTP'">
                  <span class="mx-2">{{screen_otp.substring(0,1)}}</span>
                  <span class="mx-2">{{screen_otp.substring(1,2)}}</span>
                  <span class="mx-2">{{screen_otp.substring(2,3)}}</span>
                  <span class="mx-2">{{screen_otp.substring(3,4)}}</span>
                </label>
                <label class="h5" *ngIf="OTP_type !== 'SCREEN_OTP'">
                  <span class="mx-2"></span>
                </label>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col">
              <label class="font-weight-bold-500 text-gray">
                <span>Enter OTP</span>
              </label>
            </div>
          </div>

          <div class="row form-group mx-1">
            <input id="pin1" style="border: 1px solid black !important;border-radius: 10px !important;"
              class="form-control form-control-lg text-center col  mx-2 border-0" type="text" max="1" maxlength="1"
              formControlName="pin1" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(1, $event)"
              (focus)="onFocusEvent(1)" />

            <input id="pin2" style="border: 1px solid black !important;border-radius: 10px !important;"
              class="form-control form-control-lg text-center col mx-2 border-0" type="text" max="1" maxlength="1"
              formControlName="pin2" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(2, $event)"
              (focus)="onFocusEvent(2)" />

            <input id="pin3" style="border: 1px solid black !important;border-radius: 10px !important;"
              class="form-control form-control-lg text-center col mx-2 border-0" type="text" max="1" maxlength="1"
              formControlName="pin3" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(3, $event)"
              (focus)="onFocusEvent(3)" />

            <input id="pin4" style="border: 1px solid black !important;border-radius: 10px !important;"
              class="form-control form-control-lg text-center col mx-2 border-0" type="text" max="1" maxlength="1"
              formControlName="pin4" (keypress)="numberOnly($event)" (keyup)="onKeyUpEvent(4, $event)"
              (focus)="onFocusEvent(4)" />
          </div>

          <div class="row form-group" *ngIf="OTP_type !== 'SCREEN_OTP'">
            <div class="col-6 ">
              <div [ngClass]="{'d-block': timerOn, 'd-none': !timerOn }"><span id="timer"></span> remaining</div>
            </div>
            <div class="col-6">
              <label *ngIf="!isOtpVerified && resendOTP" class="h6 small">Not recevied OTP yet click on <span
                  class="cursor text-primary" (click)="onresendOTPClick();">Resend
                  OTP</span></label>
            </div>
          </div>

          <div class="row form-group">
            <div class="col text-danger text-center">
              {{errorMessage}}
            </div>
          </div>

          <br />
          <br />
          <br />



          <div class="row">
            <div class="col">
              <small class="text-gray">By using this app you agree to our terms and conditions as per our </small>
              <small class="text-primary cursor" (click)="onClickPrivacy()">Privacy and Cookie policies</small>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</ng-template>

<ng-template #orderstatus>
  <div class="modal-body rounded">
    <div class="row form-group">
      <div class="col text-center">
        <label class="h3">Your food order
          <span *ngIf="customer_order">
            {{customer_order.ooco_sales_order_id}}
          </span>
          successfully sent
        </label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <button type="button" class="badge rounded-pill btn bg-dark-blue text-white box-shadow-none p-2 rounded"
          (click)="onCheckStatusClick()">
          Check Status
        </button>
      </div>
    </div>

  </div>
</ng-template>

<!-- <div *ngIf="ghlPaymentForm">
  <form method="post" [formGroup]="ghlPaymentForm" target="_self">
  </form>
</div> -->

<ng-template #customerDetails>
  <div class="modal-body modal-styles rounded" [formGroup]="customerDetailsForm">

    <!-- Header -->
    <div class="row align-items-center">
      <div class="col text-center">
        <label class="text-gray">
          To Process <span class="text-primary">FPX</span> payment, please provide the following
        </label>
      </div>
      <div class="col-auto">
        <button type="button" class="close close-button text-dark" data-dismiss="modal" aria-label="Close"
          (click)="onCustomerDetailCloseClick()" style="margin-top: -10px;">
          <span aria-hidden="true" style="font-size: 40px;">&times;</span>
        </button>
      </div>
    </div>

    <!-- Name input -->
    <div class="form-group">
      <input type="text" maxlength="50" formControlName="name" class="form-control" placeholder="Name"
        [ngClass]="{'has-error': ((customerDetailsForm.get('name').touched || customerDetailsForm.get('name').dirty) && customerDetailsForm.get('name').errors)}" />
    </div>

    <!-- Email input -->
    <div class="form-group">
      <input type="text" maxlength="60" formControlName="email" class="form-control" placeholder="Email"
        [ngClass]="{'has-error': ((customerDetailsForm.get('email').touched || customerDetailsForm.get('email').dirty) && customerDetailsForm.get('email').errors)}" />
    </div>

    <!-- Phone input -->
    <div class="form-group tel-wrapper">
      <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
        [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="true"
        [separateDialCode]="separateDialCode" name="mobile" formControlName="contact"
        [ngClass]="{'has-error': ((customerDetailsForm.get('contact').touched || customerDetailsForm.get('contact').dirty) && customerDetailsForm.get('contact').errors)}">
      </ngx-intl-tel-input>
    </div>

    <!-- Submit button -->
    <div class="form-group text-right">
      <button type="button" class="btn btn-outline-secondary bg-dark text-white" (click)="onCustomerNextClick()"
        [disabled]="buttonClicked">Next</button>
    </div>

  </div>
</ng-template>

<app-toast [message]="toastMessage" [visible]="showToast"></app-toast>